import React from "react";
import { Card, Tag, Button } from "antd";

import {
    CalendarOutlined,
    ClockCircleOutlined,
    EnvironmentOutlined,
    EyeOutlined,
    EditOutlined,
} from "@ant-design/icons";

import "./JdEventCard.scss";

const JdEventCard = ({ event, status, onView, onEdit,stats }) => {

    const getStatusColor = () => {
        switch (status) {
            case "UPCOMING":
                return "blue";
            case "ONGOING":
                return "green";
            case "COMPLETED":
                return "default";
            default:
                return "orange";
        }
    };

    // ReactQuill description contains HTML.
    // Convert it to plain text for the event card.
    const getPlainText = (html) => {
        if (!html) return "No description available";

        const doc = new DOMParser().parseFromString(
            html,
            "text/html"
        );

        return doc.body.textContent?.trim() ||
            "No description available";
    };

    return (
        <Card
            className="jd-event-card"
            hoverable
        >

            {/* EVENT HEADER */}
            <div className="jd-event-card-header">

                <Tag
                    color="geekblue"
                    className="jd-event-type"
                >
                    {event.eventtype || "HIRING EVENT"}
                </Tag>

                <Tag
                    color={getStatusColor()}
                    className="jd-event-status"
                >
                    {status}
                </Tag>

            </div>

            {/* EVENT TITLE */}
            <div className="jd-event-main">

                <h3 className="jd-event-title">
                    {event.eventname || "Hiring Event"}
                </h3>
                <h5 >
                    { event.qhcompanyjid }
                </h5>
                <div className="jd-event-stats">

                    <div className="jd-event-stat available">
                        <span className="stat-label">Available</span>
                        <span className="stat-count">
                            {stats.available ?? 0}
                        </span>
                    </div>

                    <div className="jd-event-stat interviewed">
                        <span className="stat-label">Interviewed</span>
                        <span className="stat-count">
                            {stats.interviewed ?? 0}
                        </span>
                    </div>

                    <div className="jd-event-stat offered">
                        <span className="stat-label">Offered</span>
                        <span className="stat-count">
                            {stats.offered ?? 0}
                        </span>
                    </div>

                </div>
            </div>

            {/* EVENT DETAILS */}
            <div className="jd-event-details">
                <div className="jd-event-detail-item">
                    <CalendarOutlined />
                    <span>
                        {event.startdate || "Not specified"}
                    </span>
                </div>

                <div className="jd-event-detail-item">
                    <ClockCircleOutlined />

                    <span>
                        {event.starttime || "Not specified"}
                    </span>
                </div>

                <div className="jd-event-detail-item jd-event-location">
                    <EnvironmentOutlined />

                    <span>
                        {event.city || event.venue || "Online"}
                    </span>
                </div>

            </div>

            {/* ACTION BUTTONS */}
            <div className="jd-event-card-footer">
                <Button
                    type="primary"
                    icon={<EyeOutlined />}
                    className="jd-event-view-btn"
                    onClick={() => onView(event)}
                >
                    View Details
                </Button>

            </div>

        </Card>
    );
};

export default JdEventCard;